/* ==========================================================================
   COLLECTING JOY — SCROLL ANIMATIONS
   ========================================================================== */

(function () {
  'use strict';

  // Scroll observer for explicit .scroll-animate elements only
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  function observeElements() {
    document.querySelectorAll(
      '.scroll-animate, .scroll-animate-left, .scroll-animate-right, .scroll-animate-scale'
    ).forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeElements);
  } else {
    observeElements();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(observeElements, 100);
    });
  }
  /* ========================================================================
     MEGA MENU — hover to open on desktop
     ======================================================================== */

  function initMegaMenuHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    document.querySelectorAll('header-menu').forEach(function (menu) {
      var details = menu.querySelector('details');
      if (!details) return;

      var closeTimer;

      menu.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover);
  } else {
    initMegaMenuHover();
  }
})();
